export default "__VITE_ASSET__a941b464__"